<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="12"> 基本信息 </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="商品名称">
            <a-input v-model="formInline.name" placeholder="请输入商品名称">
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <a-form-model-item label="销售数量">
            <a-input
              placeholder="请输入销售数量"
              v-model="formInline.stock"
            ></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="门市价">
            <a-input v-model="priceShop" placeholder="请输入门市价"> </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <a-form-model-item label="销售价">
            <a-input v-model="formInline.price" placeholder="请输入销售价">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="显示序号">
            <a-input v-model="formInline.sortNum" placeholder="请输入显示序号">
            </a-input>
          </a-form-model-item>
        </a-col>

        <a-col :span="11" :offset="2">
          <a-form-model-item label="游戏币数量">
            <a-input
              v-model="formInline.gameCurrencyNumber"
              placeholder="请输入游戏币数量"
            >
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="限购" class="aaa">
            <a-select
              :offset="2"
              size="default"
              :placeholder="
                formInline.limited == 0
                  ? '不限购'
                  : formInline.limited == 1
                  ? '限购一份'
                  : ''
              "
              style="width: 200px; margin-left: 40px"
              @change="changeLimited"
            >
              <a-select-option value="0" aria-label="不限购"
                >不限购</a-select-option
              >
              <a-select-option value="1" aria-label="限购一份"
                >限购一份</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <a-form-model-item label="套餐销售日期">
            <a-range-picker
              :placeholder="[formInline.startTime, formInline.endTime]"
              @change="onDateRangeChange"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="11">
          <a-form-model-item label="商品详情">
            <quill-editor
              v-model="introduceContent"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            >
            </quill-editor>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <a-form-model-item label="上架星期">
            <a-select
              mode="multiple"
              v-model="week"
              :default-value="week"
              style="width: 100%"
              placeholder="请选择星期"
              @change="changeWeekDay"
            >
              <a-select-option v-for="(item, index) in dateList" :key="index">
                {{ item.date }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <!-- <a-row>
        <a-col :span="11">
          <a-form-model-item label="`套餐有效期`">
            <a-input v-model="formInline.user" placeholder="请输入活动名称">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row> -->

      <a-row>
        <a-col :span="11">
          <a-form-model-item label="封面图">
            <a-upload :customRequest="upload">
              <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
                上传
              </a-button>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-table :columns="columns" :data-source="data" v-if="show"> </a-table>
    <a-button @click="save">保存</a-button>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>

<script>
import { detailTokensList, picUpload, editTokensList } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "Age",

    dataIndex: "name",
    key: "name",
    slots: { title: "customTitle" },
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    scopedSlots: { customRender: "tags" },
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
];
// import chooseAnItem from "./chooseAnItem.vue";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      priceShop: "",
      dateList: [
        {
          date: "星期一",
          value: 1,
        },
        {
          date: "星期二",
          value: 2,
        },
        {
          date: "星期三",
          value: 3,
        },
        {
          date: "星期四",
          value: 4,
        },
        {
          date: "星期五",
          value: 5,
        },
        {
          date: "星期六",
          value: 6,
        },
        {
          date: "星期天",
          value: 7,
        },
      ],
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        objId: "",
        name: "",
        price: "",
        sortNum: "",
        startTime: "",
        endTime: "",
        gameCurrencyNumber: "",
        img: "",
        limited: "",
        stock: "",
      },
      week: [],
      test: [2, 2, 2],
      data,
      columns,
      show: false,
      headImg: "",
    };
  },
  created() {
    this.getDetailTokensList();
  },
  methods: {
    changeLimited(value) {
      this.formInline.limited = +value;
    },

    upload(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error("请确保图片大小在2M以内");
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.formInline.img = res.data;
          file.onSuccess(res, file);
          message.success("上传成功");
        })
        .catch((err) => {
          message.error("请确保图片大小在2M以内");
        });
    },
    handleSubmit() {},
    changeWeekDay(value) {
      console.log("value", value);
      this.date = value;
      console.log(value, "changeWeekDay");
    },
    onDateRangeChange(date, dateString) {
      this.formInline.startTime = dateString[0];
      this.formInline.endTime = dateString[1];
    },
    goBack() {
      this.$router.push("/home/tokenPackage/tokenPackageHome");
    },
    showtable(show) {
      this.show = show;
    },
    getDetailTokensList() {
      let objId = this.$route.query.objId;
      detailTokensList(objId).then((res) => {
        this.formInline.name = res.data.name;
        this.priceShop = res.data.priceShop;
        this.formInline.sortNum = res.data.sortNum;
        this.formInline.price = res.data.spec[0].price;
        this.formInline.gameCurrencyNumber =
          res.data.spec[0].gameCurrencyNumber;
        this.formInline.objId = res.data.spec[0].objId;
        this.headImg = res.data.headImgs[0];
        this.introduceContent = res.data.introduceContent;
        this.formInline.limited = res.data.limited;
        this.formInline.startTime = res.data.spec[0].startTime;
        this.formInline.endTime = res.data.spec[0].endTime;
        this.formInline.stock = res.data.spec[0].stock;
        this.week = res.data.weekList.map((item) => {
          return item - 1;
        });

        console.log(this.week);

      });
    },

    save() {
      console.log("kjsabhdkasndmasndk");
      console.log(this.formInline);
      let objId = this.$route.query.objId;
      let obj = {
        objId: objId,
        name: this.formInline.name,
        sortNum: this.formInline.sortNum,
        priceShop: this.priceShop,
        priceDiscount: 10,
        pricePostage: 0,
        shopRunType: 1401,
        typeId: 653,
        typeSonId: 654,
        pricePostageFull: 1,
        spec: [],
        hasDistribution: false,
        goodsType: "common",
        numSales: this.formInline.stock,
        shopId: sessionStorage.getItem("shopId"),
        headImgs: [this.formInline.img],
        weekList: this.date,
        introduceContent: this.introduceContent,
        limited: this.formInline.limited,
      };
      obj.spec.push(this.formInline);
      console.log("obj", obj);
      if (obj.headImgs[0] === "") {
        obj.headImgs[0] = this.headImg;
      }
      editTokensList(obj).then((res) => {
        message.success(res.info);
        this.$router.push("/home/tokenPackage/tokenPackageHome");
      });
    },
  },
};
</script>

<style>
h1 {
  position: absolute;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/tokenPackage/tokenPackageEdit.vue